import { Client as BugsnagClient } from '@bugsnag/js';
import { Workbox } from 'workbox-window';

import { ClientLogger } from '@sxmp/logging/client';

export interface IRegistry {
  logger?: ClientLogger;
  bugsnag?: BugsnagClient;
  workbox?: Workbox;
  errorBoundary?: React.ComponentType<any>;
}

const Registry: IRegistry = {};

export default Registry;
